import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

/*
Servicio encargado de interactuar con el MS de Georeferencia
*/
class CityApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see CityApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'City');
    }
    /**
     * Metodo encargado de consultar los registros por el estado del registro
     * @param idDepartment Id del departmento
     * @param state Estado del registro a consultar
     * @param args Argumentos extra para la consulta de información
     */
    keyValueByDepartment(idDepartment, state, args) {
        const parameters = `${idDepartment}?state=${state}`;
        return this.getUri((uri) => this.httpClient.get(`${uri}/KeyValue/${parameters}`));
    }
    /**
     * Método encargado de consultar por Id de la regional retornando la información de ciudades paginada
     * @param idRegional Id de la regional
     * @param pagin Parametros de la paginación
     * @param args Argumentos extra para la consulta de información
     */
    paginationByRegional(idRegional, pagin, args) {
        const data = {
            idRegional,
            ...args,
        };
        const parameters = `${data.idRegional}?pageSize=${pagin.pageSize}&pageNumber=${pagin.pageNumber}`;
        return this.getUri((uri) => this.httpClient.get(`${uri}/PaginationByRegional/${parameters}`));
    }
    /**
     * Metodo encargado de consultar las ciudades filtrando por país y departamento
     * @param idCountry Identificador del país
     * @param idDepartment Identificador del departamento
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de las ciudades @see CityDto
     */
    getCitiesByCountryAndDepartment(idCountry, idDepartment, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetCitiesByCountryAndDepartment/${idCountry}/${idDepartment}?state=${state}`));
    }
    /**
     * Metodo encargado de consultar las ciudades filtrando por departamento
     * @param idDepartment Identificador del departamento
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de las ciudades @see CityDto
     */
    getCitiesByDepartment(idDepartment, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetCitiesByDepartment/${idDepartment}?state=${state}`));
    }
    /**
     * Metodo encargado de consultar las ciudades filtrando por departamento
     * @param idRegional Identificador de la regional
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de las ciudades @see CityDto
     */
    getCitiesByRegional(idRegional, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetCitiesByRegional/${idRegional}?state=${state}`));
    }
    /**
     * Metodo encargado de consultar las ciudades filtrando por país y departamento
     * @param code Codigo DANE de la ciudad
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de las ciudades @see CityDto
     */
    getCityByCode(code, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetCityByCode/${code}?state=${state}`));
    }
}
CityApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CityApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
CityApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CityApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CityApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 Servicio encargado de interactuar con el MS de Georeferencia
*/
class CountryApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see CityApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'Country');
    }
}
CountryApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CountryApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
CountryApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CountryApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CountryApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
Servicio encargado de interactuar con el MS de Georeferencia
*/
class DepartmentApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see DepartmentApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'Department');
    }
    /**
     * Metodo encargado de consultar los departamentos filtrando por el país
     * @param idCountry Identificador del país
     * @param state Estado de activación del registro
     * @returns Retorna un array de tipo DepartmentDto[] con la información de los registros
     */
    getDepartmentsByCountry(idCountry, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetDepartmentsByCountry/${idCountry}?state=${state}`));
    }
    /**
     * Metodo encargado de consultar los departamento filtrando por el codigo DANE
     * @param code Codigo DANE del departamento
     * @param state Estado de activación del registro
     * @returns Retorna un objeto de tipo DepartmentDto con la información del registro
     */
    getDepartmentByCode(code, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetDepartmentByCode/${code}?state=${state}`));
    }
}
DepartmentApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: DepartmentApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
DepartmentApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: DepartmentApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: DepartmentApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
Servicio encargado de interactuar con el MS de Georeferencia
*/
class GroupNodeApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see GroupNodeApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'GroupNode');
    }
}
GroupNodeApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: GroupNodeApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
GroupNodeApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: GroupNodeApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: GroupNodeApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
Servicio encargado de interactuar con el MS de Georeferencia
*/
class LocalityApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see CountryApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'Locality');
    }
    /**
     * Metodo encargado de consultar las localidades filtrando por país, department y ciudad
     * @param idCountry Identificador del país
     * @param idDepartment Identificador del departamento
     * @param idCity Identificador de la ciudad
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de las localidades @see LocalityDto
     */
    getLocalitiesByParameters(idCountry, idDepartment, idCity, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetLocalitiesByParameters/${idCountry}/${idDepartment}/${idCity}?state=${state}`));
    }
}
LocalityApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: LocalityApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
LocalityApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: LocalityApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: LocalityApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 Servicio encargado de interactuar con el MS de Georeference
*/
class NeighborhoodApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see NeighborhoodApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'Neighborhood');
    }
    /**
     * Metodo encargado de consultar los barrios filtrando por país, departamento, ciudad, localidad
     * @param idCountry Identificador del país
     * @param idDepartment Identificador del departamento
     * @param idCity Identificador de la ciudad
     * @param idLocality Identificador de la localidad
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de los barrios @see NeighborhoodDto
     */
    getNeighborhoodsByParameters(idCountry, idDepartment, idCity, idLocality, state) {
        const parameters = `${idCountry}/${idDepartment}/${idCity}/${idLocality}?state=${state}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetNeighborhoodsByParameters/${parameters}`));
    }
}
NeighborhoodApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NeighborhoodApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
NeighborhoodApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NeighborhoodApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NeighborhoodApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 Servicio encargado de interactuar con el MS de Georeference
*/
class NodeApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see NodeApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'Node');
    }
    /**
     * Metodo encargado de consultar los registros por el estado del registro
     * @param idCity Id de la ciudad
     * @param state Estado del registro a consultar
     * @param args Argumentos extra para la consulta de información
     */
    keyValueByCity(idCity, state, args) {
        const parameters = `${idCity}?state=${state}`;
        return this.getUri((uri) => this.httpClient.get(`${uri}/KeyValue/${parameters}`));
    }
    /**
     * Metodo encargado de consultar los registros por el estado del registro y la regional
     * @param idRegional Id de la ciudad
     * @param state Estado del registro a consultar
     * @param args Argumentos extra para la consulta de información
     */
    keyValueByRegional(idRegional, state, args) {
        const parameters = `${idRegional}?state=${state}`;
        return this.getUri((uri) => this.httpClient.get(`${uri}/KeyValueByRegional/${parameters}`));
    }
    /**
     * Método encargado de consultar por Id del nodo fisico de la operación asignado el funcionario, retornando la información paginada
     * @param idCity Id de la ciudad
     * @param pagin Parametros de la paginación
     * @param args Argumentos extra para la consulta de información
     */
    paginationByCity(idCity, pagin, args) {
        const data = {
            idCity,
            ...args,
        };
        const parameters = `${data.idCity}?pageSize=${pagin.pageSize}&pageNumber=${pagin.pageNumber}`;
        return this.getUri((uri) => this.httpClient.get(`${uri}/Pagination/${parameters}`));
    }
    /**
     * Método encargado de consultar por Id de la regional retornando la información de nodos paginada
     * @param idRegional Id de la regional
     * @param pagin Parametros de la paginación
     * @param args Argumentos extra para la consulta de información
     */
    paginationByRegional(idRegional, pagin, args) {
        const data = {
            idRegional,
            ...args,
        };
        const parameters = `${data.idRegional}?pageSize=${pagin.pageSize}&pageNumber=${pagin.pageNumber}`;
        return this.getUri((uri) => this.httpClient.get(`${uri}/PaginationByRegional/${parameters}`));
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a un Nodo en específico
     * @param idCity Id de la ciudad
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de los nodos @see NodeDto
     */
    getNodesByCity(idCity, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetNodesByCity/${idCity}?state=${state}`));
    }
    /***
    * Metodo encargado de consultar nodos por una lista de canales y el id del pais
    * @param args Argumentos para la consulta de información
    * @returns Returns un array con la información de los nodos @see NodeDto
    */
    getNodesByCodesChannelIdCountry(args) {
        return this.getUri(uri => this.httpClient.post(`${uri}/GetNodesByCodesChannelIdCountry`, args));
    }
}
NodeApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NodeApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
NodeApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NodeApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NodeApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
Servicio encargado de interactuar con el MS de Georeferencia
*/
class RegionalApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see RegionalApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'Regional');
    }
    /**
     * Metodo encargado de consultar los departamentos por país
     * @param idCountry Identificador del país
     * @param state Estado de activación del registro
     * @returns Retorna un array de tipo DepartmentDto[] con la información de los registros
     */
    getRegionalsByCountry(idCountry, state) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetRegionalsByCountry/${idCountry}?state=${state}`));
    }
}
RegionalApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: RegionalApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
RegionalApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: RegionalApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: RegionalApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 Servicio encargado de interactuar con el MS de Georeferencia
*/
class TypeNodeApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see TypeNodeApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'georeference', 'TypeNode');
    }
}
TypeNodeApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeNodeApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
TypeNodeApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeNodeApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeNodeApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of georeference
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CityApiService, CountryApiService, DepartmentApiService, GroupNodeApiService, LocalityApiService, NeighborhoodApiService, NodeApiService, RegionalApiService, TypeNodeApiService };
